import { inject, Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from '../../environments/environment';

import { MessageService } from '../message.service';
import { ProfileService } from '../profile.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: true,
    imports: [RouterModule]
})
export class DashboardComponent implements OnInit {

  private messageService: MessageService = inject(MessageService);
  private profileService: ProfileService = inject(ProfileService);
  env = environment;

  ngOnInit(): void {
    this.messageService.set(`Welcome back ${this.profileService.getFirstName()}!`);
  }

}
